import React from "react";

function ProjectEndMessageHtml(props) {
  return <div dangerouslySetInnerHTML={{ __html: props.html }} />;
}

export default ProjectEndMessageHtml;
